import { gateway } from "../../../../gateway";

export interface CompanyPaymentsStatus {
  companyId: number;
  paypal: boolean;
  stripe: boolean;
}

export async function fetchCompanyPaymentsStatus(companyId: string | number) {
  const token = sessionStorage.getItem("token");

  const res = await gateway.get(`/invoices/payments/self/`, {
    headers: { Authorization: token ?? "" },
  });

  return (res.data?.data ?? res.data) as CompanyPaymentsStatus;
}
